import { first, get, isArray, isFunction, size } from 'lodash-es'
import { useFormContext, useFieldValidator } from '../context'
import FormRow from '../row'
import { useCallback, useEffect, useMemo } from 'react'
import SelectContent from './content'

export default function FormSelect({
  label,
  placeholder,
  valueKey = 'value',
  data,
  labelRight,
  prop,
  onError,
  className,
  disabled,
  required = false,
  noError = false,
  innerClassName,
  onClick,
  onChange
}) {

  const { xs, sm, md, lg, xl, rules, formData, changeField, pushFieldsVerify } = useFormContext()
  const val = get(formData, prop, '')
  const rule = get(rules, prop)
  const [, errors, verify] = useFieldValidator(rule, val, prop)
  const hasError = useMemo(() => size(errors) > 0, [errors])
  const verifyFn = useCallback(() => {
    return verify(rule ? { type: isArray(rule.trigger) ? first(rule.trigger) : rule.trigger } : undefined)
  }, [verify, rule])

  useEffect(() => {
    pushFieldsVerify(prop, verifyFn)
  }, [verifyFn, pushFieldsVerify, prop])
  useEffect(() => {
    isFunction(onError) && onError(errors)
  }, [onError, errors])

  function changeHandle(value) {
    changeField(prop, get(value, valueKey, value))
    isFunction(onChange) && onChange(value)
  }

  return (
    <FormRow label={label} labelRight={labelRight} noError={noError} errors={errors} required={required} className={className}>
      <SelectContent
        data={data}
        valueKey={valueKey}
        placeholder={placeholder}
        disabled={disabled}
        defaultValue={val}
        onChange={changeHandle}
        xs={xs}
        sm={sm}
        md={md}
        lg={lg}
        xl={xl}
        error={hasError}
        innerClassName={innerClassName}
        onClick={onClick}
      ></SelectContent>
    </FormRow>
  )
}